export const AUTH_HOLLAEX_LOGO = `${process.env.PUBLIC_URL}/assets/img/hollaex-email-white.png`;
export const AUTH_BITHOLLA_FAVICON = `${process.env.PUBLIC_URL}/assets/img/grey-dash-icon-login.png`;
export const AUTH_BG = `${process.env.PUBLIC_URL}/assets/img/auth-bg-1.jpg`;
export const AUTH_DOCS_BG = `${process.env.PUBLIC_URL}/assets/img/auth-docs-bg.png`;
export const AUTH_FORUM_BG = `${process.env.PUBLIC_URL}/assets/img/auth-forum-bg.jpg`;
export const AUTH_TOKEN_BG = `${process.env.PUBLIC_URL}/assets/img/auth-token-bg.jpg`;
export const AUTH_ACCESSORY_BG = `${process.env.PUBLIC_URL}/assets/img/auth-accessory-bg.jpg`;
export const AUTH_ARTICLE_BG = `${process.env.PUBLIC_URL}/assets/img/auth-article-bg.jpg`;
export const AUTH_HAP_BG = `${process.env.PUBLIC_URL}/assets/img/auth-hap-bg.png`;
export const AUTH_CLI_BG = `${process.env.PUBLIC_URL}/assets/img/auth-cli-bg.jpg`;
export const AUTH_GRADIANT_BG = `${process.env.PUBLIC_URL}/assets/img/auth-gradiant-bg.jpg`;
export const AUTH_UPDATE_BG = `${process.env.PUBLIC_URL}/assets/img/auth-update-bg.jpg`;
export const AUTH_COLLATERAL_BG = `${process.env.PUBLIC_URL}/assets/img/auth-collateral-bg.jpg`;
export const AUTH_VAULT_BG = `${process.env.PUBLIC_URL}/assets/img/auth-vault-bg.png`;
export const AUTH_COLLATERAL_FAVICON = `${process.env.PUBLIC_URL}/assets/img/collateral-icon.svg`;

export const AUTH_VAULT_ICON = `${process.env.PUBLIC_URL}/assets/img/vault-grey-dial.svg`;
export const AUTH_VAULT_NAME = `${process.env.PUBLIC_URL}/assets/img/vault-name.svg`;

export const DASH_NAV_HOLLA_ICON = `${process.env.PUBLIC_URL}/assets/img/hollaex-icon-dashboard-main-nav.png`;
export const DASH_NAV_PROJECT_ICON = `${process.env.PUBLIC_URL}/assets/img/rocket-icon.svg`;
export const DASH_NAV_PROJECT_ACTIVE_ICON = `${process.env.PUBLIC_URL}/assets/img/rocket-icon-active.svg`;
export const DASH_NAV_WALLET_ICON = `${process.env.PUBLIC_URL}/assets/img/wallet-icon.svg`;
export const DASH_NAV_WALLET_ACTIVE_ICON = `${process.env.PUBLIC_URL}/assets/img/wallet-icon-active.svg`;
export const MAIN_PANEL_BACKGROUND_RIGHT = `${process.env.PUBLIC_URL}/assets/img/main-panel-1.png`;
export const MAIN_PANEL_BACKGROUND_LEFT = `${process.env.PUBLIC_URL}/assets/img/main-panel.png`;
export const EXCHANGE_PANEL_BACKGROUND_LEFT = `${process.env.PUBLIC_URL}/assets/img/exchange-panel-wave-graphics-left.png`;
export const EXCHANGE_PANEL_BACKGROUND_RIGHT = `${process.env.PUBLIC_URL}/assets/img/exchange-panel-wave-graphics-right.png`;
export const GLOBAL_LANGUAGE = `${process.env.PUBLIC_URL}/assets/img/global-language.svg`;
export const LIGHT_THEME_CANDLES = `${process.env.PUBLIC_URL}/assets/img/Light-theme-candles.svg`;
export const DARK_THEME_CANDLES = `${process.env.PUBLIC_URL}/assets/img/dark-theme-candles.svg`;

export const FLAG_UK = `${process.env.PUBLIC_URL}/assets/img/active-en.png`;
export const FLAG_KO = `${process.env.PUBLIC_URL}/assets/img/active-kr.png`;

export const EXCHANGE_CARD_ICON = {
	1: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-01.svg`,
	2: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-02.svg`,
	3: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-03.svg`,
	4: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-04.svg`,
	5: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-05.svg`,
	6: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-06.svg`
};

export const EXCHANGE_CARD_ICON_BLACK = {
	1: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-black-01.svg`,
	2: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-black-02.svg`,
	3: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-black-03.svg`,
	4: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-black-04.svg`,
	5: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-black-05.svg`,
	6: `${process.env.PUBLIC_URL}/assets/img/hex-pattern-icon-black-06.svg`
};

export const WALLET_ENTERPRISE_PACK = `${process.env.PUBLIC_URL}/assets/img/Enterprise_Wallet-pack.png`;
export const WALLET_BUSINESS_PACK = `${process.env.PUBLIC_URL}/assets/img/Business_Wallet-pack.png`;
export const WALLET_LITE_PACK = `${process.env.PUBLIC_URL}/assets/img/Lite_Wallet-pack.png`;
export const WALLET_UPGRADE_ICON = `${process.env.PUBLIC_URL}/assets/img/vault-upgrade-icon.svg`;
export const WARNING = `${process.env.PUBLIC_URL}/assets/img/warning.svg`;
export const EMAIL_SENT = `${process.env.PUBLIC_URL}/assets/img/email-sent.svg`;

export const XHT_WHITE = `${process.env.PUBLIC_URL}/assets/img/XHT-grey.png`;

export const NEW_WALLET_ICON = `${process.env.PUBLIC_URL}/assets/img/new-wallet-icon.svg`;
export const RECOVER_WALLET_ICON = `${process.env.PUBLIC_URL}/assets/img/recover-wallet-icon.svg`;

export const HOLLA_HEADER_LOGO = `${process.env.PUBLIC_URL}/assets/img/holla-header-logo.png`;

export const PC_MONITOR = `${process.env.PUBLIC_URL}/assets/img/pc-monitor.png`;
export const LOGO_HOLLAEX = `${process.env.PUBLIC_URL}/assets/img/hollaex-email-black.png`;

export const HEX_LOGO_BLACK = `${process.env.PUBLIC_URL}/assets/img/XHT-black.png`;
export const HEX_LOGO_WHITE = `${process.env.PUBLIC_URL}/assets/img/XHT-white.png`;

export const SETUP_TECH_IMAGE = `${process.env.PUBLIC_URL}/assets/img/setup-biz.png`;
export const SETUP_TECH_IMAGE_ON = `${process.env.PUBLIC_URL}/assets/img/setup-biz-on.jpg`;
export const SETUP_BIZ_IMAGE = `${process.env.PUBLIC_URL}/assets/img/setup-tech.png`;

export const VAULT_IMAGE = `${process.env.PUBLIC_URL}/assets/img/Vault-01.svg`;
export const PLUGIN_IMAGE = `${process.env.PUBLIC_URL}/assets/img/plugin-board-page.svg`;
export const HELP_IMAGE = `${process.env.PUBLIC_URL}/assets/img/help-chat-section.svg`;

export const ICON_ADMIN = `${process.env.PUBLIC_URL}/assets/img/admin-controls-01-t.svg`;
export const ICON_KEY = `${process.env.PUBLIC_URL}/assets/img/api-key-icon-01.svg`;
export const ICON_SEARCH = `${process.env.PUBLIC_URL}/assets/img/asset-list-icon-01.svg`;
export const ICON_BOX = `${process.env.PUBLIC_URL}/assets/img/box-blue-tap.svg`;
export const ICON_LIST = `${process.env.PUBLIC_URL}/assets/img/check-list.svg`;
export const ICON_QUESTION = `${process.env.PUBLIC_URL}/assets/img/help-learn-icon-01.svg`;
export const ICON_WALLET = `${process.env.PUBLIC_URL}/assets/img/my-wallet-icon-01.svg`;
export const ICON_BILLING = `${process.env.PUBLIC_URL}/assets/img/bill-icon.svg`;
export const ICON_RESTORE = `${process.env.PUBLIC_URL}/assets/img/restore-wallet-icon-01.svg`;
export const ICON_WAVE = `${process.env.PUBLIC_URL}/assets/img/wave-icon-01.svg`;
export const ICON_ALL_PLUGIN = `${process.env.PUBLIC_URL}/assets/img/all-plugins-icon-01.svg`;
export const ICON_MY_PLUGIN = `${process.env.PUBLIC_URL}/assets/img/my-plugins-icon-01.svg`;
export const ICON_REQUEST = `${process.env.PUBLIC_URL}/assets/img/request-plugin-icon-01.svg`;
// export const ICON_CONTACTUS = `${process.env.PUBLIC_URL}/assets/img/contact-us-icon.svg`;
export const ICON_CONTACTUS = `${process.env.PUBLIC_URL}/assets/img/FreshDesk-support.svg`;
export const ICON_CHARGE = `${process.env.PUBLIC_URL}/assets/img/charge-bolt-01.svg`;

export const EXCHANGE_COLLATERAL_PAGE_BG = `${process.env.PUBLIC_URL}/assets/img/exchange-collateral-page-bg.png`;
export const EXCHANGE_COLLATERAL_POPUP_BG = `${process.env.PUBLIC_URL}/assets/img/exchange-collateral-popup-bg.png`;
export const EXCHANGE_COLLATERAL_INSUFFICIENT_BG = `${process.env.PUBLIC_URL}/assets/img/insufficient-collateral-bg.png`;

export const SETUP_MASTER = `${process.env.PUBLIC_URL}/assets/img/dash-man.png`;
export const SETUP_MASTER_ON = `${process.env.PUBLIC_URL}/assets/img/dash-man-on.png`;
export const EXCHANGE_COLLATERAL_SUCCESS_BG = `${process.env.PUBLIC_URL}/assets/img/exchange-collateral-success-bg.png`;

export const XHT_ICON = `${process.env.PUBLIC_URL}/assets/img/xht-icon-dark.svg`;
export const XHT_ICON_LIGHT = `${process.env.PUBLIC_URL}/assets/img/xht-icon-light.svg`;
export const XHT_ICON_BLUE = `${process.env.PUBLIC_URL}/assets/img/xht-icon-blue.svg`;
export const XHT_ICON_WHITE = `${process.env.PUBLIC_URL}/assets/img/xht-icon-white.svg`;
export const XHT_HAND_ICON = `${process.env.PUBLIC_URL}/assets/img/xht-sponsorship-hand-icon.svg`;

export const BITHOLLA_PAYMENT_BRAND = `${process.env.PUBLIC_URL}/assets/img/hollaex-icon-dashboard-main-nav.png`;
export const CLOUD_OUTLINE = `${process.env.PUBLIC_URL}/assets/img/ios-cloudy-night-outline.svg`;
export const FIRE_BALL = `${process.env.PUBLIC_URL}/assets/img/fireball-icon.svg`;
export const BANK_ICON = `${process.env.PUBLIC_URL}/assets/img/bank-icon.svg`;
export const CLOUD_ICON = `${process.env.PUBLIC_URL}/assets/img/cloud-icon.svg`;
export const CLOUD_ICON_ANIMATED = `${process.env.PUBLIC_URL}/assets/img/cloud-exchange-launching.gif`;
export const DIY_ICON = `${process.env.PUBLIC_URL}/assets/img/diy-icon.svg`;
export const DIY_GREY_ICON = `${process.env.PUBLIC_URL}/assets/img/diy-grey-icon.svg`;
export const ENTERPRISE_ICON = `${process.env.PUBLIC_URL}/assets/img/enterprise-dash-icon-01.svg`;
export const ENTERPRISE_GREY_ICON = `${process.env.PUBLIC_URL}/assets/img/enterprise-dash-grey-icon-01.svg`;
export const WALLET_SELECTED = `${process.env.PUBLIC_URL}/assets/img/wallet-selected.svg`;
export const WALLET_BLUE_SELECTED = `${process.env.PUBLIC_URL}/assets/img/wallet-selected-blue.svg`;
export const WALLET_BTC_ICON = `${process.env.PUBLIC_URL}/assets/img/wallet-only-btc-icon.svg`;
export const CURRENCY_SYMBOL = `${process.env.PUBLIC_URL}/assets/img/noun_currency.svg`;
export const EMAIL_PAY_PROCESSED = `${process.env.PUBLIC_URL}/assets/img/send-email-pay-processed.svg`;

export const VERSION_TICK = `${process.env.PUBLIC_URL}/assets/img/verification-tick.svg`;
export const UK_FLAG = `${process.env.PUBLIC_URL}/assets/img/uk-flag.png`;
export const VERIFICATION_TICK_ICON = `${process.env.PUBLIC_URL}/assets/img/verification-tick.svg`;
export const VERIFICATION_ERROR_ICON = `${process.env.PUBLIC_URL}/assets/img/verification-error.svg`;
export const BLUE_COG_SETTINGS_ICON = `${process.env.PUBLIC_URL}/assets/img/blue-cog-settings.svg`;
export const PERSON = `${process.env.PUBLIC_URL}/assets/img/person.svg`;
export const SETTINGS = `${process.env.PUBLIC_URL}/assets/img/noun_settings.svg`;
export const BLOCKCHAIN_BACKGROUND = `${process.env.PUBLIC_URL}/assets/img/blockchain-background.svg`;
export const FIAT_BACKGROUND = `${process.env.PUBLIC_URL}/assets/img/fiat-background.svg`;
export const HELP_DESCRIPTION_POPUP = `${process.env.PUBLIC_URL}/assets/img/help-popup-description.png`;
export const HELP_FOOTER_POPUP = `${process.env.PUBLIC_URL}/assets/img/help-popup-footer.png`;
export const USER_INFO_DETAILS = `${process.env.PUBLIC_URL}/assets/img/user-info-details-page.svg`;
export const EXCHANGE_KEY_DETAILS = `${process.env.PUBLIC_URL}/assets/img/keys-sideways-point-right-01.svg`;
export const EXCHANGE_KEY_REFRESH = `${process.env.PUBLIC_URL}/assets/img/reissue-exchange-keys.svg`;

export const SUCCESS_COLLATERAL_VIEDO = `${process.env.PUBLIC_URL}/assets/video/success-collateral.mp4`;

// Account level icons
export const ACCOUNT_ICON = {
	Level_1: `${process.env.PUBLIC_URL}/assets/img/level-1.svg`,
	Level_2: `${process.env.PUBLIC_URL}/assets/img/level-2.svg`,
	Level_3: `${process.env.PUBLIC_URL}/assets/img/level-3.svg`,
	Level_4: `${process.env.PUBLIC_URL}/assets/img/level-4.svg`,
	Level_5: `${process.env.PUBLIC_URL}/assets/img/level-5.svg`,
	Level_6: `${process.env.PUBLIC_URL}/assets/img/level-6.svg`,
	Level_7: `${process.env.PUBLIC_URL}/assets/img/level-7.svg`,
	Level_8: `${process.env.PUBLIC_URL}/assets/img/level-8.svg`,
	Level_9: `${process.env.PUBLIC_URL}/assets/img/level-9.svg`,
	Level_10: `${process.env.PUBLIC_URL}/assets/img/level-10.svg`
};

export const COIN_ICONS = {
	ada: `${process.env.PUBLIC_URL}/assets/img/ada-icon.svg`,
	bch: `${process.env.PUBLIC_URL}/assets/img/bch-icon.svg`,
	eth: `${process.env.PUBLIC_URL}/assets/img/eth-icon.svg`,
	btc: `${process.env.PUBLIC_URL}/assets/img/btc-icon.svg`,
	bnb: `${process.env.PUBLIC_URL}/assets/img/bnb-icon.svg`,
	dai: `${process.env.PUBLIC_URL}/assets/img/dai-icon.svg`,
	eos: `${process.env.PUBLIC_URL}/assets/img/eos-icon.svg`,
	ltc: `${process.env.PUBLIC_URL}/assets/img/ltc-icon.svg`,
	trx: `${process.env.PUBLIC_URL}/assets/img/trx-icon.svg`,
	tusd: `${process.env.PUBLIC_URL}/assets/img/tusd-icon.svg`,
	xlm: `${process.env.PUBLIC_URL}/assets/img/xlm-icon.svg`,
	xmr: `${process.env.PUBLIC_URL}/assets/img/xmr-icon.svg`,
	xrp: `${process.env.PUBLIC_URL}/assets/img/xrp-icon.svg`
};
export const MISSING_ICON = `${process.env.PUBLIC_URL}/assets/img/missing-coin.svg`;

export const UPGRADE_POPUP_RESTART_ICON = `${process.env.PUBLIC_URL}/assets/img/apply-latest-kit-upgrade-pop-01.gif`;
export const RESTART_POPUP_RESTART_ICON = `${process.env.PUBLIC_URL}/assets/img/restart-circle.svg`;
export const RESTART_CIRCLE_BLUE_ICON = `${process.env.PUBLIC_URL}/assets/img/restart-circle-blue.svg`;
export const TIME_COMING_SOON_ICON = `${process.env.PUBLIC_URL}/assets/img/time-coming-soon.svg`;
export const MISSING_GO_BACK_TO_DASH = `${process.env.PUBLIC_URL}/assets/img/missing-page-go-back-to-dash.svg`;
export const BASIC_COIN_DROP = `${process.env.PUBLIC_URL}/assets/img/Basic-coin-drop.svg`;
export const PRO_COIN_DROP = `${process.env.PUBLIC_URL}/assets/img/pro-coin-drop.svg`;
export const STANDARD_COIN_DROP = `${process.env.PUBLIC_URL}/assets/img/standard-coin-drop.svg`;
export const CURRENT_PLAN_CLOUD_ICON = `${process.env.PUBLIC_URL}/assets/img/current-plan-cloud-icon.svg`;
export const MANAGE_SERVER_REGION_ICON = `${process.env.PUBLIC_URL}/assets/img/manage-server-region.svg`;
export const WHITE_SET_SERVER_REGION_ICON = `${process.env.PUBLIC_URL}/assets/img/white-set-server-region-popup.svg`;
export const FLAG_SINGAPORE_ICON = `${process.env.PUBLIC_URL}/assets/img/flag-singapore.png`;
export const FLAG_UK_ICON = `${process.env.PUBLIC_URL}/assets/img/flag-uk.png`;
export const FLAG_FR_ICON = `${process.env.PUBLIC_URL}/assets/img/flag-fr.png`;
export const SET_SERVER_REGION_ICON = `${process.env.PUBLIC_URL}/assets/img/set-server-region.svg`;
export const EXCHANGE_BOX_LAUNCH_PLACEHOLDER = `${process.env.PUBLIC_URL}/assets/img/exchange box launch placeholder graphic.svg`;
export const APPLY_REFRESH_ICON = `${process.env.PUBLIC_URL}/assets/img/update-refresh-circle-arrow.svg`;
export const APPLY_REFRESH_BLACK_ICON = `${process.env.PUBLIC_URL}/assets/img/update-refresh-circle-arrow-black.svg`;
export const CLOUD_COLLATERAL_COVERED = `${process.env.PUBLIC_URL}/assets/img/cloud-collateral-covered.svg`;
export const GOING_PUBLIC_COLLATERAL_GLOBE = `${process.env.PUBLIC_URL}/assets/img/going-public-collateral-globe.svg`;
export const GOING_PUBLIC_COLLATERAL_GLOBE_GREEN = `${process.env.PUBLIC_URL}/assets/img/going-public-collateral-globe-green.svg`;
export const GOING_PUBLIC_COLLATERAL_GLOBE_BLACK = `${process.env.PUBLIC_URL}/assets/img/going-public-collateral-globe-black.svg`;
export const TIER_MEMBER = `${process.env.PUBLIC_URL}/assets/img/tier-member.png`;
export const LITE_MEMBER = `${process.env.PUBLIC_URL}/assets/img/lite-member.png`;
export const HOLLA_MEMBER = `${process.env.PUBLIC_URL}/assets/img/holla-member.png`;
export const XHT_REMOVAL_IN_PROCESS = `${process.env.PUBLIC_URL}/assets/img/XHT-removal-in-process.svg`;
export const PLUGIN_TAB_ACTIVE_ICON = `${process.env.PUBLIC_URL}/assets/img/plugin-img.svg`;
export const PLUGIN_TAB_ICON = `${process.env.PUBLIC_URL}/assets/img/plugin-img-white.svg`;
export const DEFAULT_PLUGIN_THUMBNAIL = `${process.env.PUBLIC_URL}/assets/img/default-plugin-thumbnail.png`;
export const ANNOUNCEMENT_PLUGIN_THUMBNAIL = `${process.env.PUBLIC_URL}/assets/img/announcement-plugin-thumbnail.jpg`;
export const DEFAULT_PLUGIN_PREVIEW = `${process.env.PUBLIC_URL}/assets/img/default-plugin-preview-image.png`;

export const XHT_ICON_ORANGE = `${process.env.PUBLIC_URL}/assets/img/xht-icon-orange.svg`;
export const REVOKE_EXCHANGE_KEY = `${process.env.PUBLIC_URL}/assets/img/revoke-exchange-keys-01.svg`;
export const PUBLIC_EXCHANGE_WARNING = `${process.env.PUBLIC_URL}/assets/img/live-public-exchange-warning.svg`;
export const CLOSE_TERMINATE_ICON = `${process.env.PUBLIC_URL}/assets/img/terminate-red-cross.svg`;
export const EXCHANGE_SWITCH_ICON = `${process.env.PUBLIC_URL}/assets/img/switch_exchange_state.svg`;
export const LOGS_BACKUP_ICON = `${process.env.PUBLIC_URL}/assets/img/Group 2180.svg`;

export const FIAT_MASTER_PLAN_BACKGROUND = `${process.env.PUBLIC_URL}/assets/img/cloud_basic_graphic-01.png`;
export const CRYPTO_PRO_PLAN_BACKGROUND = `${process.env.PUBLIC_URL}/assets/img/Mask_Group_69.png`;
export const BASIC_PLAN_BACKGROUND = `${process.env.PUBLIC_URL}/assets/img/cloud_fiat_ramp_graphic-01.png`;

export const CUSTOM_EXCHANGE_VIDEO = `${process.env.PUBLIC_URL}/assets/img/EXCHANGE_VIDEO.png`;
export const CUSTOM_EDIT_COLOR = `${process.env.PUBLIC_URL}/assets/img/EDIT_COLOR.png`;
export const CUSTOM_EDIT_EXCHANGE = `${process.env.PUBLIC_URL}/assets/img/EDIT_EXCHANGE.png`;
export const CUSTOMIZE_TOP_ICON = `${process.env.PUBLIC_URL}/assets/img/CUSTOMIZE_TOP_ICON.svg`;
export const GIT_ICON = `${process.env.PUBLIC_URL}/assets/img/GIT_ICON.svg`;


export const EMAIL_PENDING_ICON = `${process.env.PUBLIC_URL}/assets/img/check-email-pending.svg`;
export const EURO_FLAG = `${process.env.PUBLIC_URL}/assets/img/euro-flag.png`;
export const KOREA_FLAG = `${process.env.PUBLIC_URL}/assets/img/korea-flag.png`;
export const EDIT_ICON = `${process.env.PUBLIC_URL}/assets/img/edit-pen.svg`;

export const KYC_PLUGIN_ICON = `${process.env.PUBLIC_URL}/assets/img/kyc-plugin-icon.svg`;
export const KYC_USER_ICON = `${process.env.PUBLIC_URL}/assets/img/kyc-user-icon.svg`;

export const GENERAL_KEY_TABLE = `${process.env.PUBLIC_URL}/assets/img/general-key-table.svg`;
export const MASTER_KEY_TABLE = `${process.env.PUBLIC_URL}/assets/img/master-key-table.svg`;
export const MASTER_KEY_TABLE_SMALL = `${process.env.PUBLIC_URL}/assets/img/master-key-table-small.svg`;
export const REVOKE_MASTER_KEY = `${process.env.PUBLIC_URL}/assets/img/revoke-main-key.svg`;

export const DIY_BOOST_ICON = `${process.env.PUBLIC_URL}/assets/img/diy-boost-man-on-fire.svg`;

export const BUILT_DOMAIN_ICON =`${process.env.PUBLIC_URL}/assets/img/built-domain.png`;
export const CUSTOM_DOMAIN_ICON =`${process.env.PUBLIC_URL}/assets/img/custom_domain.png`;
export const DOMAIN_ICON = `${process.env.PUBLIC_URL}/assets/img/domain-icon.gif`;
export const FLAIR_ICON =`${process.env.PUBLIC_URL}/assets/img/Cloudflare_Logo.svg`;

export const EVENT_LOADING=`${process.env.PUBLIC_URL}/assets/img/gif-animated-blue-dots-queued-state-for-row-dashboard-events.gif`;

export const IN_QUEUE_GIF =`${process.env.PUBLIC_URL}/assets/img/cloud-event-queued.svg`;
export const IN_PROGRESS_GIF =`${process.env.PUBLIC_URL}/assets/img/hollaex-cloud-event-in-progress-0E0E0F.gif`;
export const FINAL_STATE_GIF =`${process.env.PUBLIC_URL}/assets/img/Group-3509.svg`;
export const CLOUD_EVENT_FAILED =`${process.env.PUBLIC_URL}/assets/img/cloud-event-failed.png`;

export const START_CLOUD_EXCHANGE =`${process.env.PUBLIC_URL}/assets/img/Start-cloud-exchange-pop-up-01.gif`;
export const STOPPING_POP_LOOP =`${process.env.PUBLIC_URL}/assets/img/stopping-pop-loop-01.gif`;

export const STARTING_EXCHANGE =`${process.env.PUBLIC_URL}/assets/img/starting-exchange-03.gif`;
export const FINAL_STARTING_EXCHANGE_SUCCESS =`${process.env.PUBLIC_URL}/assets/img/final-starting-exchange-success-04.gif`;

export const EMAIL_DOMAIN = `${process.env.PUBLIC_URL}/assets/img/email-domain.svg`;
export const EMAIL_DOMAIN_SET = `${process.env.PUBLIC_URL}/assets/img/email-domain-set.svg`;

export const AUTO_EMAIL_SETUP = `${process.env.PUBLIC_URL}/assets/img/auto-emails-setup-complete-01.gif`;

export const AUTO_EMAIL_APPLY = `${process.env.PUBLIC_URL}/assets/img/auto-emails-apply-02.gif`;
export const AUTO_EMAIL_SETUP_FINALIZING =  `${process.env.PUBLIC_URL}/assets/img/auto-emails-setup-finalizing-03.gif`;
export const SET_EMAIL_SUCCESS =  `${process.env.PUBLIC_URL}/assets/img/set-email-success-03.gif`;
export const EXCHANGE_GURU_DAN = `${process.env.PUBLIC_URL}/assets/img/Exchange-guru-dan-small-profile-hollaex-dashboard-01.jpg`
export const SAMPLE_EARTH = `${process.env.PUBLIC_URL}/assets/img/earth.jpg`

export const TERMINATE_STATE_IMAGE =  `${process.env.PUBLIC_URL}/assets/img/terminate-state-message-graphic.png`;

export const ONLY_GRID =  `${process.env.PUBLIC_URL}/assets/video/only-grid.mp4`;
export const LION_BTC =  `${process.env.PUBLIC_URL}/assets/video/lion-holden-btc-top-down.mp4`;
export const HOLLAEX_PC_YOUTUBE =  `${process.env.PUBLIC_URL}/assets/video/HollaEx_PC_YouTube_background.mp4`;
export const HARD_SIDE_SHOT_BLUE_BEAM =  `${process.env.PUBLIC_URL}/assets/video/hard_side_shot_with_right_long_horizontal_blue_beam.mp4`;
export const TEST_VIDEO =  `${process.env.PUBLIC_URL}/assets/video/hollaex-man-test-video-login-background.mp4`;
export const SIDE_VIEW =  `${process.env.PUBLIC_URL}/assets/video/Side_view_open_box_purple_radiant-04.mp4`;
export const HOLLAX_MAN_LOOKING_DOWN =  `${process.env.PUBLIC_URL}/assets/video/hollax_man_looking_down_and_blue_radiant.mp4`;
export const NEXT_STEP_WEB_3 =  `${process.env.PUBLIC_URL}/assets/video/next_step_web_3.mp4`;
export const OTC_BROKER_ARCADE =  `${process.env.PUBLIC_URL}/assets/video/otc_broker_arcade_box_with_coin_stickers.mp4`;
export const BOX_WITH_FLOPPY =  `${process.env.PUBLIC_URL}/assets/video/box_with_floppy_disk_blue_Japanese_gradient.mp4`;
export const FRONT_SHOT_FLOPPY =  `${process.env.PUBLIC_URL}/assets/video/front_shot_of_box_open_with_floppy_disk_visible_above.mp4`;
export const DARK_GRID_COMPUTER =  `${process.env.PUBLIC_URL}/assets/video/dark_grid_computer_orange_screen.mp4`;
export const ZIG_ZAG_LINES =  `${process.env.PUBLIC_URL}/assets/video/zig_zag_lines.mp4`;
export const HOLLAEX_MAN_LEFT =  `${process.env.PUBLIC_URL}/assets/video/hollax_man_on_the_left_and_blue_radient_bitcoin.mp4`;
export const SMALL_HOVERING_MAN =  `${process.env.PUBLIC_URL}/assets/video/small_hovering_hollaex_man_on_triangle_island_grid_against_black_hole-center.mp4`;
export const LARGE_HOVERING_MAN =  `${process.env.PUBLIC_URL}/assets/video/Large_hovering_hollaex_man_on_triangle_island_gird_with_blue_gradient.mp4`;

export const TEXT_VIDEO_BACKGROUND =  `${process.env.PUBLIC_URL}/assets/video/text-video-background-01.mp4`;

export const HOLLAEX_WHITE =  `${process.env.PUBLIC_URL}/assets/img/hollaex-white.svg`;

export const BACKGROUND_TO_DO_LIST =  `${process.env.PUBLIC_URL}/assets/img/Mask-Group-111.svg`;
export const GLOBAL_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Group-2055.svg`;
export const BACKGROUND_GLOBAL_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Mask-Group-107.svg`;
export const COIN_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Path-4735.svg`;
export const BACKGROUND_COIN_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Mask-Group-108.svg`;
export const TRAD_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Group-1849.svg`;
export const BACKGROUND_TRAD_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Mask-Group-109.svg`;
export const BILLING_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Group-1850.svg`;
export const BACKGROUND_BILLING_EXCHANGE =  `${process.env.PUBLIC_URL}/assets/img/Mask-Group-110.svg`;
export const DASH_GLOBE =  `${process.env.PUBLIC_URL}/assets/img/Dash-globe.svg`;

export const CLOUD_PLAN_BASIC =  `${process.env.PUBLIC_URL}/assets/img/cloud-plan-dash-board-icons-basic.svg`;
export const CLOUD_PLAN_CRYPTO_PRO =  `${process.env.PUBLIC_URL}/assets/img/cloud-plan-dash-board-icons-crypto-pro.svg`;
export const CLOUD_PLAN_CRYPTO_PRO_FIAT_RAMP = `${process.env.PUBLIC_URL}/assets/img/stacked-pro-on-fiat.svg`
export const CLOUD_PLAN_FIAT_RAMP =  `${process.env.PUBLIC_URL}/assets/img/cloud-plan-dash-board-icons-fiat-ramp.svg`;
export const HOLLAEX_NETWORK_WHITE =  `${process.env.PUBLIC_URL}/assets/img/HollaEx network-icon-white-(s)-01.svg`;

export const OPERATOR_INCOMPLETE = `${process.env.PUBLIC_URL}/assets/img/operator-incomplete.svg`;
export const OPERATOR_SUBMIT = `${process.env.PUBLIC_URL}/assets/img/operator-pending.svg`;
export const OPERATOR_COMPLETE = `${process.env.PUBLIC_URL}/assets/img/operator-complete.svg`;

export const BUSINESS_INCOMPLETE = `${process.env.PUBLIC_URL}/assets/img/business-incomplete.svg`;
export const BUSINESS_SUBMIT = `${process.env.PUBLIC_URL}/assets/img/business-pending.svg`;
export const BUSINESS_COMPLETE = `${process.env.PUBLIC_URL}/assets/img/business-complete.svg`;

export const AGREEMENT_INCOMPLETE = `${process.env.PUBLIC_URL}/assets/img/agreement-sign-incomplete.svg`;
export const AGREEMENT_SUBMIT = `${process.env.PUBLIC_URL}/assets/img/agreement-sign-pending.svg`;
export const AGREEMENT_COMPLETE = `${process.env.PUBLIC_URL}/assets/img/agreement-sign-complete.svg`;
export const CLOCK = `${process.env.PUBLIC_URL}/assets/img/clock.svg`;

export const PLUGIN_HOME = `${process.env.PUBLIC_URL}/assets/img/Mask Group 265.png`;
export const PLUGIN_STORE_ICON = `${process.env.PUBLIC_URL}/assets/img/hollaex-exchange-store-plugin-apps.svg`;
export const PLUGIN_NEW_EXCHANGE = `${process.env.PUBLIC_URL}/assets/img/Group 5962.png`;
export const OPEN_HOLLAEX_DOC_APP_CREATION = `${process.env.PUBLIC_URL}/assets/img/open-hollaex-doc-app-creation-link.svg`;
export const ONE_TIME_ACTIVATION_PLUGIN = `${process.env.PUBLIC_URL}/assets/img/One-time activation-plugin.svg`;
export const VERIFIED_BADGE = `${process.env.PUBLIC_URL}/assets/img/verified-badge.svg`;
export const CREDITS = `${process.env.PUBLIC_URL}/assets/img/credits-plugin.svg`;

export const PIECHART = `${process.env.PUBLIC_URL}/assets/img/metrics-colored-pie-chart.svg`;
export const COLOREDBAR = `${process.env.PUBLIC_URL}/assets/img/cloud-logs-colored-bars.svg`;
export const NODATA = `${process.env.PUBLIC_URL}/assets/img/antdNodata.svg`;

export const INSTALL_PLUGIN = `${process.env.PUBLIC_URL}/assets/img/Group 6196.png`;
export const BANXA_PLUGIN = `${process.env.PUBLIC_URL}/assets/img/banxa-hollaex-plugin.png`;
export const DEVELOP_PLUGIN = `${process.env.PUBLIC_URL}/assets/img/Group 6198.png`;
export const BACKUPEVENT_GIF =`${process.env.PUBLIC_URL}/assets/img/hollaex-cloud-event-backup-in-progress-hex212022.gif`;